<div class="modal-header">
	<h1 class="modal-title">
		Content Alert
		<i aria-hidden="true" class="fas fa-triangle-exclamation text-warning"></i>
	</h1>
	<button
		class="btn btn-outline-dark"
		title="Close"
		type="button"
		(click)="activeModal.dismiss()"
	>
		<i aria-hidden="true" class="far fa-times"></i>
	</button>
</div>
<div class="modal-body">
	Your message contains inappropriate language. Are you sure you want to send
	it?
</div>
<div class="modal-footer">
	<button
		class="btn btn-secondary"
		id="gabby.profanity.confirm.cancel"
		type="button"
		(click)="activeModal.dismiss()"
	>
		Cancel
	</button>

	<button
		class="btn btn-primary"
		id="gabby.profanity.confirm.close"
		type="button"
		(click)="closeModal()"
	>
		Send Anyway
	</button>
</div>
